import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["p", "br", "strong", "em", "u", "b", "i", "h2", "h3", "ul", "ol", "li", "a"];
const ALLOWED_ATTR = ["href", "target", "rel"];

/** Sanitize sales email HTML for safe in-app preview / rendering. */
export function sanitizeSalesEmailHtml(html: string | null | undefined): string {
  if (!html) {
    return "";
  }
  return DOMPurify.sanitize(html, {
    ALLOWED_ATTR,
    ALLOWED_TAGS,
  });
}

/**
 * True when TipTap (or similar) HTML has no meaningful text content.
 * Empty editor often serializes as `<p></p>`.
 */
export function isEmptySalesEmailBody(html: string | null | undefined): boolean {
  if (!html?.trim()) {
    return true;
  }
  const text = html
    .replace(/<br\s*\/?>/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, "")
    .trim();
  return text.length === 0;
}

/** Convert legacy plain-text bodies into simple HTML paragraphs for TipTap. */
export function plainTextToEditorHtml(text: string): string {
  if (!text) {
    return "";
  }
  if (/<\s*\/?\s*(p|br|strong|em|u|b|i|h[1-6]|ul|ol|li|a)\b/i.test(text)) {
    return text;
  }
  const escaped = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return escaped
    .split(/\r\n|\r|\n/)
    .map((line) => `<p>${line || "<br>"}</p>`)
    .join("");
}
